import { browserNotificationInteractionFactory } from './browserNotificationInteractionFactory';
import { notificationInteractionFactory } from './notificationInteractionFactory';
import { notificationUsageFactory } from './notificationUsageFactory';
import { sidebarNotificationInteractionFactory } from './sidebarNotificationInteractionFactory';
export const propertiesFactory = (name, meta, notification) => {
  const lookup = {
    browserNotificationsInteraction: browserNotificationInteractionFactory,
    notificationInteraction: notificationInteractionFactory,
    notificationUsage: notificationUsageFactory,
    sidebarNotificationInteraction: sidebarNotificationInteractionFactory
  };
  return lookup[name](meta, notification);
};